import { inject, Injectable, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatterRequisitionPrecedent } from '@models/requisitions';
import { SnackbarService } from '@services/ui/snackbar.service';
import { BaseRequisitionModal } from '../base-requisition-modal';
import LogRocket from 'logrocket';
import { Store, TypedSelector } from '@ngxs/store';

export interface IBaseMatterRequisitionModalData {
	selectedRequisitionId?: string;
}

@Injectable()
export abstract class BaseMatterRequisitionModal<T extends { id: string }>
	extends BaseRequisitionModal<T>
	implements OnInit
{
	protected store = inject(Store);
	abstract selector: TypedSelector<
		(requisitionId: string) => MatterRequisitionPrecedent
	>;
	public selectedRequisition: MatterRequisitionPrecedent;

	constructor(
		protected data: IBaseMatterRequisitionModalData,
		protected dialogRef: MatDialogRef<unknown, string>,
		protected snackbarService: SnackbarService,
	) {
		super(dialogRef, snackbarService);
	}

	ngOnInit(): void {
		super.ngOnInit();
		if (this?.data?.selectedRequisitionId) {
			this.selectedRequisition = this.store.selectSnapshot(this.selector)(
				this.data.selectedRequisitionId,
			);
			if (!this.selectedRequisition) {
				this.dialogRef.close();
				this.snackbarService.openSnackBar({
					text: 'Requisition not found',
					type: 'error',
				});
				LogRocket.error('Requisition not found');
			}
		}
	}
}
